<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                  
                <div class="row mb-5">
                    <div class="col-lg-3">
                        <edit-association-side-nav />
                    </div>
                    <div class="col-lg-9 mt-lg-0 mt-4">
                        <association-detail />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import EditAssociationSideNav from "./components/EditAssociationSideNav.vue"
import AssociationDetail from "./components/AssociationDetail.vue"

export default {
    name: 'Asoociation_edit_page',
    components: {
        EditAssociationSideNav,
        AssociationDetail
    },
    data() {
        return {
            Id: '',
            association: [],
            gets: []
        }
    },
    async mounted() {
        
    },
}
</script>